import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const MorphoGradient = props => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M3.89905 12.1929V16.559C3.89905 16.8277 4.12651 16.9393 4.19728 16.9646C4.26805 16.9951 4.50561 17.061 4.71791 16.8632L8.02082 13.6891C8.3021 13.4189 8.57356 13.1348 8.77756 12.8023C8.87358 12.6461 8.91338 12.558 8.91338 12.558C9.11559 12.1473 9.11559 11.7518 8.91837 11.3562C8.62532 10.768 7.87715 10.1696 6.74989 9.60168L4.82407 10.6767C4.25289 11.0013 3.89905 11.5743 3.89905 12.1929Z" fill="#00378A" />;
    t1 = <path d="M2 2.4821V7.06114C2 7.63415 2.38417 8.14123 2.93009 8.3035C4.79024 8.84101 8.03032 9.99718 8.81383 11.6959C8.91485 11.919 8.97553 12.1371 8.99587 12.3653C9.51649 11.417 9.75404 10.3268 9.64285 9.22133C9.49114 7.65442 8.66212 6.2295 7.36817 5.32181L2.75317 2.09164C2.67228 2.03079 2.57624 2.00037 2.48021 2.00037C2.39932 2.00037 2.32856 2.01558 2.25274 2.05615C2.10109 2.14235 2 2.29955 2 2.4821Z" fill="#2470FF" />;
    t2 = <path d="M16.1838 12.1929V16.559C16.1838 16.8277 15.9564 16.9393 15.8856 16.9646C15.8149 16.9951 15.5772 17.061 15.365 16.8632L11.9852 13.6153C11.7551 13.3942 11.5354 13.1603 11.3621 12.8924C11.2249 12.6803 11.1695 12.558 11.1695 12.558C10.9673 12.1473 10.9673 11.7518 11.1643 11.3562C11.4576 10.768 12.2058 10.1696 13.3328 9.60168L15.2588 10.6767C15.8351 11.0013 16.1838 11.5743 16.1838 12.1929Z" fill="#00378A" />;
    t3 = <path d="M18.086 2.48174V7.06076C18.086 7.63377 17.7017 8.14086 17.1558 8.30313C15.2957 8.84064 12.0556 9.99682 11.2721 11.6956C11.1709 11.9187 11.1103 12.1367 11.0901 12.3649C10.5695 11.4167 10.3319 10.3264 10.4431 9.22097C10.5946 7.65405 11.4237 6.22914 12.7178 5.32145L17.3328 2.09128C17.4137 2.03042 17.5097 2 17.6057 2C17.6866 2 17.7574 2.01521 17.8331 2.05578C17.9848 2.14199 18.086 2.29918 18.086 2.48174Z" fill="#2470FF" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default MorphoGradient;